
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Create and append DNS prefetch links
const prefetchDomains = [
  'fonts.googleapis.com',
  'fonts.gstatic.com',
  'www.googletagmanager.com'
];

// Create and append DNS prefetch links in a non-blocking way
setTimeout(() => {
  prefetchDomains.forEach(domain => {
    const link = document.createElement('link');
    link.rel = 'dns-prefetch';
    link.href = `//${domain}`;
    document.head.appendChild(link);
  });
}, 0);

// Use createRoot with a non-blocking approach
const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  
  // Render in the next microtask to avoid blocking the main thread
  setTimeout(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }, 0);
}
